import React, { useRef } from "react";
import { Divider, Typography } from "@mui/material";
import IntroductionImg3 from "../../../assets/SvgIcons/IntroductionImg3.svg";
import "../JaldiLab.css";
import {
  DividerBorderStyle,
  dimensionStyle,
  getTextContentHeading,
  h1style,
  h2style,
  h3style,
  paraStyle,
  referenceHtml,
  referenceStyle,
  referenceTootKit,
  sectionStyle,
} from "./ChapterList";
import designConsideration from "../../../assets/SvgIcons/design-consideration.svg";
import entranceATM from "../../../assets/Images/Entrance_ATM.png";
import bankATM from "../../../assets/Images/Bank_ATM .png";
import retailSpace from "../../../assets/Images/retail_space.jpeg";
import eatery from "../../../assets/Images/Eatery.png";
import outdooAreaRetailSpace from "../../../assets/Images/outdoor_area_for_retail spaces.png";
import CaptionWithBorders1 from "../../../components/ChapterImage/Image";
import { ImageDesc94, ImageDesc95, ImageDesc96, ImageDesc97, ImageDesc98 } from "../../../utils/tmp/ImageDescription/AncillaryAmenitiesID";

function AncillaryAmenities({ goToSection }) {
  const referencesRef = useRef(null);

  const handleScrollToReferences = () => {
    if (referencesRef.current) {
      referencesRef.current.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };

  const reference = (_data, number) => {
    return referenceTootKit(_data, number, handleScrollToReferences);
  };

  const referenceData = [
    {
      content: " Harmonised Guidelines 2021, p. 373, Section 6.17.",
      link: "",
      description: "",
    },
    {
      content: "Harmonised Guidelines 2021, p. 347, Section 6.6",
      link: "",
      description: "",
    },
    {
      content: "Harmonised Guidelines 2021, p. 347, Section 6.6",
      link: "",
      description: "",
    },
  ];

  const DesignConsiderations = {
    icon: <img src={designConsideration} />,
    heading: "Design Considerations",
    data: [
      "Universal accessibility must be ensured through all spaces with a human-centric approach for diverse user groups, this includes seamless access to entrances, pathways and inside the spaces for Persons with Disabilities, persons with strollers/prams, provision for seatings, etc.",

      <>
        Accessible sanitary provisions must be provided in close proximity to
        ensure that the amenities remain clean and well-maintained. For further
        details of the design of the sanitary provisions, please refer to
        <span
          onClick={() => {
            goToSection("sanitaryProvisions", "sanitaryProvisions");
          }}
          style={sectionStyle}
        >
          {" "}
          Section 3.1{" "}
        </span>
        .
      </>,

      "The layout of the public area must facilitate easy navigation, and adequate space must be allotted to accommodate necessary equipment and minimize congestion and overcrowding. ",

      "The spaces must be adaptable and flexible, to accommodate various other services which may be required.",

      "Technology such as user-friendly interfaces, self-service kiosks, etc., must be provided to improve service efficiency.",

      "Waste management must be efficiently managed for the entire Court Complex, including ancillary amenities.",

      <>
        Adequate security measures, including standard door-frame metal
        detectors with people counters and surveillance systems with the
        presence of trained personnel, must be provided to ensure safety. For
        further details on security provisions, please refer to{" "}
        <span
          style={sectionStyle}
          onClick={() => goToSection("annexes", "HeadingAnnexure3")}
        >
          Annexure 3
        </span>
        .
      </>,
    ],

    isOrdered: true,
    isImage: true
  };

  const SpaceDesignConsiderations = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",
    data: [
      "The entrance to the ATM and the bank facilities must have a leveled entrance with ramps, if required, and handrails on either side. The steps must have color contrasting strips and provision of TGSI tiles leading up to the entrance.",

      "ATM kiosks must be designed  to be of an  accessible height.",

      <>
        The screen and keyboard of the ATM machine must be visible from the
        height of <span style={dimensionStyle}>1000 mm</span> above the floor
        level. All controls and buttons must be provided in the range of{" "}
        <span style={dimensionStyle}>400</span> to{" "}
        <span style={dimensionStyle}>1200 mm</span> from the floor level. The
        machine must be placed at a minimum distance of{" "}
        <span style={dimensionStyle}>600 mm</span> from any corner.
        {reference(referenceData[0], 1)}
      </>,

      <>
        The entrance door must be of clear width of{" "}
        <span style={dimensionStyle}>900 mm</span>, and the room must have
        adequate space for the wheelchair to maneuver with a turning diameter of
        <span style={dimensionStyle}>1500mm</span>.
      </>,

      "The infrastructure must ensure comprehensive voice guidance for ATM operations and across different bank ATM card transactions. Assistance through audible features must incorporate Text-To-Speech (“TTS”) voices with a bilingual Indian accent.",

      "The system must include a user-friendly keypad operation similar to an IVR, with Braille labels for enhanced accessibility.",
    ],

    isOrdered: true,
    isImage: true
  };

  const vendorDesignConsiderations = {
    icon: <img src={designConsideration} />,
    heading: "Specific Design Considerations",
    data: [
      "The entrance to all retail shops in the Court Complex or spaces for vendors must be levelled with a ramp.",

      <>
        The entrances of the shops or retail units must not have high
        thresholds. In case there is one, it must be made accessible through
        ramped kerbs or must not exceed the height of{" "}
        <span style={dimensionStyle}>25 mm</span>.
        {reference(referenceData[1], 2)}
      </>,

      <>
        Wherever counters are present, either for viewing, exchanging, payments
        or for information, they must be universally accessible to facilitate
        people who could be standing, wheelchair users or people with shorter
        stature.{reference(referenceData[2], 3)}
      </>,

      "Retail and space for vendors must be considered for diverse typology such as bookstalls, stationery shops, photocopiers, eateries, stamp vendors, and other such requirements with consideration to accessible infrastructure. ",
    ],

    isOrdered: true,
    isImage: true
  };

  return (
    <div>
      <Typography>
        <h1 id="handbookPrinciple" style={h1style}>
          PART C - THE HANDBOOK
        </h1>{" "}
        <h2 id="commonAmenities" style={h2style}>
          <span style={{ fontSize: "24px" }}>3.</span>COMMON AMENITIES
        </h2>
        <h3 id="mainheading" style={h3style}>
          <span style={{ fontSize: "20px" }}>3.7. </span>Ancillary Amenities
        </h3>
        <p style={paraStyle}>
          Various ancillary amenities must additionally be provided within the
          Court Complex. These may be provided in the public areas outside the
          main Court buildings, adjacent to the parking spaces.
        </p>
        {getTextContentHeading(DesignConsiderations)}
        <DividerBorderStyle />
        <h4 id="facilities" style={h3style}>
          <span style={{ fontSize: "20px" }}>3.7.</span>A. ATM and Bank
          Facilities
        </h4>
        {getTextContentHeading(SpaceDesignConsiderations)}
        <CaptionWithBorders1
          image={[entranceATM]}
          caption="Image 94: Example of accessible entrance to a bank ATM"
          creditLabel="Source"
          imageCredit="Harmonised Guidelines 2021."
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc94}
        />
        <CaptionWithBorders1
          image={[bankATM]}
          caption="Image 95: Example of accessible ATM provisions"
          creditLabel="Source"
          imageCredit="Union Bank of India"
          zoomImgStyle={{ height: "300px" }}
          imageDescription={ImageDesc95}
        />
        <DividerBorderStyle />
        <h4 id="vendors" style={h3style}>
          <span style={{ fontSize: "20px" }}>3.7.</span>B. Retail and Space for
          Vendors
        </h4>
        {getTextContentHeading(vendorDesignConsiderations)}
        <CaptionWithBorders1
          image={[retailSpace]}
          caption={"Image 96: Example of accessible retail spaces"}
          creditLabel={"Image Credit"}
          imageCredit={"369 Ochre Studio"}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc96}
        />
        <CaptionWithBorders1
          image={[outdooAreaRetailSpace]}
          caption={"Image 97: Example of outdoor area for retail spaces"}
          creditLabel={"Source"}
          imageCredit={"Harmonised Guidelines 2021, p. 151"}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc97}
        />
        <CaptionWithBorders1
          image={[eatery]}
          caption={"Image 98: Example of accessible entrance to an eatery"}
          height="500px"
          creditLabel={"Source"}
          imageCredit={"Harmonised Guidelines 2021, p. 246"}
          zoomImgStyle={{ height: "500px" }}
          imageDescription={ImageDesc98}
        />
        <h2 ref={referencesRef} id="reference" style={referenceStyle}>
          References
          <Divider />
        </h2>
        {referenceHtml(referenceData)}
      </Typography>
    </div>
  );
}

export default AncillaryAmenities;
